export enum FAVORITE_ICON_STATE {
  FILLED = 'ds-icon-favorites_star_filled',
  OUTLINE = 'ds-icon-favorites-star_outline',
}

export const GRID_IS_COMPACT = 'grid-is-compact';
export const ROW_IS_EDITABLE = 'row-is-editable';
export const DATA_LOAD_MORE = 'more-items-loading';
